import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledLabel = styled.label `
    display: block;
    color: #6f6f6e;
    font-size: 14px;
    font-weight: 600;
`;
const Label = ({ children }) => (_jsx(StyledLabel, { children: children }));
export default Label;
